import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    enableEnergyLabelLink: true,
    discountsAPI: {
        enableDeliveryOffersAddon: true,
        endpoint: 'https://web-api.ikea.com/wdm/api/discounts/get',
    },
};
